import { createSlice } from "@reduxjs/toolkit"
import { WEBCHAT_AGENT_ANALYTICS } from "../../../../constants/reducer_names"

const initialState = {
    checked_column: [
        "Agent Name",
        "Received Chats",
        "Responded Chats",
        "Abandoned Chats",
        "Missed Chats",
        "Transferred Chats",
        "Total chat duration",
        "Avg. chat duration",
        "Interactions from Customer",
        "Interactions from Agent",
        "Total Interactions"
    ] as any,
    checked_column2: [
        "Agent Name",
        "Avg. Response Time",
        "Avg. Handle Time (AHT)",
        "Maximum Handle Time",
        // "Agent Idle time",
        "Total ACW Time",
        "Avg. Hold Time",
        "Avg. Queue Wait Time",
        "Maximum Queue Wait Time",
        "Occupancy Rate (%)",
        "First Chat Resolution (%)",
        // "Customer Satisfaction (%)"
    ] as any,
    checked_column3: [
        "Agent Name",
        "Chat Type",
        "SL1",
        "SL2",
        "SL3",
        "SL4",
        "SL5",
        "SL6",
        "Total",
        "Missed Chats",
        "SLA Achieved (%)",
        "SLA Breached (%)"
    ] as any,
    titleMapper_ForDb: {
        "Agent Name": "agentName",
        "Received Chats": "receivedChat",
        "Responded Chats": "respondedChat",
        "Abandoned Chats": "abandonedChat",
        "Missed Chats": "missedChat",
        "Transferred Chats": "transferredChat",
        "Total chat duration": "totalChatDuration",
        "Avg. chat duration": "avgChatDuration",
        "Interactions from Customer": "customerMsgCount",
        "Interactions from Agent": "agentMsgCount",
        "Total Interactions": "totalMsgCount"
    } as any,
    titleMapper_ForDb2: {
        "Agent Name": "agentName",
        "Avg. Response Time": "averageResponseTime",
        "Avg. Handle Time (AHT)": "averageHandledTime",
        "Maximum Handle Time": "MaximumHandledTime",
        // "Agent Idle time": "agentIdleTimeCount",
        "Total ACW Time": "totalACWTime",
        "Avg. Hold Time": "averageHoldtime",
        "Avg. Queue Wait Time": "averageQueueWaittime",
        "Maximum Queue Wait Time": "maximumQueueWaittime",
        "Occupancy Rate (%)": "occupancyRate",
        "First Chat Resolution (%)": "firstChatResolution",
        // "Customer Satisfaction (%)": "SentimentalScore"
    } as any,
    titleMapper_ForDb3: {
        "Agent Name": "agentName",
        "Chat Type": "ChatType",
        "SL1": "SL1",
        "SL2": "SL2",
        "SL3": "SL3",
        "SL4": "SL4",
        "SL5": "SL5",
        "SL6": "SL6",
        "Total": "TotalSLA",
        "Missed Chats": "MissedChats",
        "SLA Achieved (%)": "SLAAchieved",
        "SLA Breached (%)": "SLAbreached"
    } as any,
    updated_TableColumn: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },

        {
            title: 'Received Chats',
            dataIndex: 'receivedChat',
            key: 'receivedChat',
        },
        {
            title: 'Responded Chats',
            dataIndex: 'respondedChat',
            key: 'respondedChat',
        },
        {
            title: 'Abandoned Chats',
            dataIndex: 'abandonedChat',
            key: 'abandonedChat',
        },
        {
            title: 'Missed Chats',
            dataIndex: 'missedChat',
            key: 'missedChat',
        },
        {
            title: 'Transferred Chats',
            dataIndex: 'transferredChat',
            key: 'transferredChat',
        },
        {
            title: 'Total chat duration',
            dataIndex: 'totalChatDuration',
            key: 'totalChatDuration',
        },
        {
            title: 'Avg. chat duration',
            dataIndex: 'avgChatDuration',
            key: 'avgChatDuration',
        },
        {
            title: 'Interactions from Customer',
            dataIndex: 'customerMsgCount',
            key: 'customerMsgCount',
        },
        {
            title: 'Interactions from Agent',
            dataIndex: 'agentMsgCount',
            key: 'agentMsgCount',
        },
        {
            title: 'Total Interactions',
            dataIndex: 'totalMsgCount',
            key: 'totalMsgCount',
        }
    ] as any,
    updated_TableColumn2: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Avg. Response Time',
            dataIndex: 'averageResponseTime',
            key: 'averageResponseTime',
        },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'averageHandledTime',
            key: 'averageHandledTime',
        },
        {
            title: '% Max Handle Time',
            dataIndex: 'MaximumHandledTime',
            key: 'MaximumHandledTime',
        },
        // {
        //     title: 'Agent Idle time',
        //     dataIndex: 'agentIdleTimeCount',
        //     key: 'agentIdleTimeCount',
        // },
        {
            title: 'Total ACW Time',
            dataIndex: 'totalACWTime',
            key: 'totalACWTime',
        },
        {
            title: 'Avg. Hold Time',
            dataIndex: 'averageHoldtime',
            key: 'averageHoldtime',
        },
        {
            title: 'Avg. Queue Wait Time',
            dataIndex: 'averageQueueWaittime',
            key: 'averageQueueWaittime',
        },
        {
            title: 'Maximum Queue Wait Time',
            dataIndex: 'maximumQueueWaittime',
            key: 'maximumQueueWaittime',
        },
        {
            title: 'Occupancy Rate (%)',
            dataIndex: 'occupancyRate',
            key: 'occupancyRate',
        },
        {
            title: 'First Chat Resolution (%)',
            dataIndex: 'firstChatResolution',
            key: 'firstChatResolution',
        },
        // {
        //     title: 'Customer Satisfaction (%)',
        //     dataIndex: 'SentimentalScore',
        //     key: 'SentimentalScore',
        // }
    ] as any,
    updated_TableColumn3: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Chat Type',
            dataIndex: 'ChatType',
            key: 'ChatType',
        },
        {
            title: 'SL1',
            dataIndex: 'SL1',
            key: 'SL1',
        },
        {
            title: 'SL2',
            dataIndex: 'SL2',
            key: 'SL2',
        },
        {
            title: 'SL3',
            dataIndex: 'SL3',
            key: 'SL3',
        },
        {
            title: 'SL4',
            dataIndex: 'SL4',
            key: 'SL4',
        },
        {
            title: 'SL5',
            dataIndex: 'SL5',
            key: 'SL5',
        },
        {
            title: 'SL6',
            dataIndex: 'SL6',
            key: 'SL6',
        },
        {
            title: 'Total',
            dataIndex: 'TotalSLA',
            key: 'TotalSLA',
        },
        {
            title: 'Missed Chats',
            dataIndex: 'MissedChats',
            key: 'MissedChats',
        },
        {
            title: 'SLA Achieved (%)',
            dataIndex: 'SLAAchieved',
            key: 'SLAAchieved',
        },
        {
            title: 'SLA Breached (%)',
            dataIndex: 'SLAbreached',
            key: 'SLAbreached',
        },
    ] as any
}

const agentAnalyticsWebchatSlice = createSlice({
    name: WEBCHAT_AGENT_ANALYTICS,
    initialState,
    reducers: {
        checkedColumn: (state, { payload }) => {
            state.checked_column = payload.checked_column;
        },
        checkedColumn2: (state, { payload }) => {
            state.checked_column2 = payload.checked_column2;
        },
        checkedColumn3: (state, { payload }) => {
            state.checked_column3 = payload.checked_column3;
        },
        titleMapperForDb: (state, { payload }) => {
            state.titleMapper_ForDb = payload.titleMapper_ForDb;
        },
        titleMapperForDb2: (state, { payload }) => {
            state.titleMapper_ForDb2 = payload.titleMapper_ForDb2;
        },
        titleMapperForDb3: (state, { payload }) => {
            state.titleMapper_ForDb3 = payload.titleMapper_ForDb3;
        },
        updatedTableColumn: (state, { payload }) => {
            state.updated_TableColumn = payload.updated_TableColumn;
        },
        updatedTableColumn2: (state, { payload }) => {
            state.updated_TableColumn2 = payload.updated_TableColumn2;
        },
        updatedTableColumn3: (state, { payload }) => {
            state.updated_TableColumn3 = payload.updated_TableColumn3;
        },


    }
})

export const agentAnalyticsWebchatSliceActions = agentAnalyticsWebchatSlice.actions;
export const agentAnalyticsWebchatSliceReducer = agentAnalyticsWebchatSlice.reducer